// import Swiper bundle with all modules installed
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

Swiper.use([Navigation, Pagination]);

// ...rest of your code...

document.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
        document.documentElement.classList.add("scrolling");
    } else {
        document.documentElement.classList.remove("scrolling");
    }
});

function swiperInit() {
  console.log('swiperInit function called');

  for (let i = 0; i < 10; i++) {
    const swiperCats = new Swiper(`.featured-cat-posts`, {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        540: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: `.category-button-next-${i}`,
        prevEl: `.category-button-prev-${i}`,
      },
    });
  }

  for (let i = 0; i < 10; i++) {
    const swiperCats = new Swiper(`.featured-cat-posts-${i}`, {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        540: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: `.category-button-next-${i}`,
        prevEl: `.category-button-prev-${i}`,
      },
    });
  }

  const swiperWhatsOn = new Swiper('.whats-on-posts', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      540: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 60,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next-whats-on ',
      prevEl: '.swiper-button-prev-whats-on ',
    },
  });

    // init Swiper:
  const swiperTeam = new Swiper('.team-members', {
    slidesPerView: 1,
    spaceBetween: 10,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      540: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 60,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next-team',
      prevEl: '.swiper-button-prev-team',
    },
  });

  const swiperGalleryFull = new Swiper('.swiper-gallery-full', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      540: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
    },
  });

  const swiperCalendar = new Swiper('.events-calendar-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    draggable: false,
    navigation: {
      nextEl: '.swiper-button-next-calendar',
      prevEl: '.swiper-button-prev-calendar',
    },
  });
}

function responsiveVideo() {
  console.log('responsiveVideo function called');
  document.querySelectorAll('.responsive-video').forEach(function(video) {
    let hasLoaded = false;
    console.log('Processing video element:', video);
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasLoaded) {
          const desktop = video.dataset.desktop;
          const mobile = video.dataset.mobile;
          let src = '';

          if (window.innerWidth > 768 && desktop) {
            src = desktop;
          } else if (window.innerWidth <= 768 && mobile) {
            src = mobile;
          } else if (desktop) {
            src = desktop;
          } else if (mobile) {
            src = mobile;
          } else {
            // No source available, do nothing
            return;
          }

          // Remove existing sources
          while (video.firstChild) {
            video.removeChild(video.firstChild);
          }

          // Add new source
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          console.log('video source set to:', src);

          hasLoaded = true;
          obs.unobserve(video);
        }
      });
    }, { threshold: 0.1 });

    observer.observe(video);
  });


  document.querySelectorAll('.video-player-wrapper').forEach(function(wrapper) {
    const button = wrapper.querySelector('.video-player-toggle');
    const video = wrapper.querySelector('.video-player');
    if (!button || !video) return;

    button.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        wrapper.classList.add('playing');
      } else {
        video.pause();
        wrapper.classList.remove('playing');
      }
    });
  });
}

function mobileMenu() {
  function onToggleNavigationInteraction(callback) {
    const el = document.getElementById('toggle-navigation');
    if (!el) return;

    let touched = false;

    el.addEventListener('touchstart', function (e) {
    touched = true;
    callback(e);
    }, { passive: true });

    el.addEventListener('click', function (e) {
    if (touched) {
      touched = false;
      return;
    }
    callback(e);
    }, { passive: true });
  }

  function submenuToggleInit() {
    document.querySelectorAll('.submenu-toggle').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      const parentLi = btn.closest('li');
      if (parentLi) {
      parentLi.classList.toggle('open');
      }
    }, { passive: true });
    });
  }


  onToggleNavigationInteraction(function(e) {
    console.log('Navigation toggle interaction detected');
    const html = document.documentElement;
    html.classList.toggle('mobile-menu-open');
  });
  submenuToggleInit();
}

function dropdownToggle() {
  console.log('dropdownToggle function called');
  document.querySelectorAll('.dropdown').forEach(function(dropdown) {
    const button = dropdown.querySelector('.dropdown-toggle');
    button.addEventListener('click', function(e) {
      dropdown.classList.toggle('open');
    }, { passive: true });
  });
}

window.onload = () => {
  console.log('window.onload event fired');
  document.documentElement.classList.add('loaded');
  responsiveVideo();
  swiperInit();
  mobileMenu();
  dropdownToggle();
};

